/** Text of the optional "Flattened on ..." note: the person's local time with the zone name, or UTC. */
export type StampZone = "local" | "utc";

export function flattenStampText(date: Date, zone: StampZone = "local", timeZone?: string): string {
  const tz = zone === "utc" ? "UTC" : timeZone;
  let parts: Record<string, string> = {};
  try {
    const fmt = new Intl.DateTimeFormat("en-CA", { timeZone: tz, year: "numeric", month: "2-digit", day: "2-digit", hour: "2-digit", minute: "2-digit", hourCycle: "h23", timeZoneName: "short" });
    for (const p of fmt.formatToParts(date)) parts[p.type] = p.value;
  } catch {
    parts = {};
  }
  if (!parts.year) return `Flattened on ${date.toISOString().replace("T", " ").slice(0, 16)} UTC`;
  // The note is drawn in Helvetica, which only holds basic Latin: keep the zone name to plain characters.
  const name = (parts.timeZoneName ?? "UTC").replace(/[^\x20-\x7e]/g, "").trim() || "UTC";
  return `Flattened on ${parts.year}-${parts.month}-${parts.day} ${parts.hour}:${parts.minute} ${name}`;
}
